import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  min-height: 150px;
  max-height: 150px;
`;
